import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, Calendar, Maximize, ArrowRight } from 'lucide-react';
import { portfolio } from '../data/mock';

const Portfolio = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('Tous');

  const categories = ['Tous', ...new Set(portfolio.map(item => item.category))];

  const filteredPortfolio = selectedCategory === 'Tous'
    ? portfolio
    : portfolio.filter(item => item.category === selectedCategory);

  const handleProjectClick = (projectId) => {
    navigate(`/projet/${projectId}`);
  };

  return (
    <section id="realisations" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-block bg-[#c9a961]/10 text-[#c9a961] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Nos Réalisations
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3C] mb-6">
            Des projets qui parlent d'eux-mêmes
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez nos rénovations d'appartements parisiens, alliant respect du patrimoine 
            et modernité pour un résultat d'exception.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                selectedCategory === category
                  ? 'bg-[#c9a961] text-white shadow-lg scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPortfolio.map((project) => (
            <Card
              key={project.id}
              onClick={() => handleProjectClick(project.id)}
              className="group overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              {/* Image Container */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3C]/90 via-[#0B1F3C]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Category Badge */}
                <div className="absolute top-4 right-4">
                  <Badge className="bg-[#c9a961] text-white border-0 px-3 py-1">
                    {project.category}
                  </Badge>
                </div>

                {/* Hover Info */}
                <div className="absolute bottom-4 left-4 right-4 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="flex items-center gap-4 text-white text-sm mb-3">
                    <div className="flex items-center gap-1">
                      <Maximize size={16} />
                      <span>{project.surface}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar size={16} />
                      <span>{project.duration}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-white font-semibold">
                    <span>Voir le projet</span>
                    <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-[#0B1F3C] mb-2 group-hover:text-[#c9a961] transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {project.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-3 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#c9a961] mb-2">15+</div>
            <div className="text-gray-600 font-medium">Années d'Expérience</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#c9a961] mb-2">98%</div>
            <div className="text-gray-600 font-medium">Clients Satisfaits</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-[#c9a961] mb-2">25+</div>
            <div className="text-gray-600 font-medium">Artisans Qualifiés</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
